// Module
var code = "<template class=\"comp-loader\"><svg class=\"loader\" width=\"20px\" height=\"20px\" viewBox=\"0 0 66 66\"><circle class=\"circle\" fill=\"none\" stroke-width=\"6\" stroke-linecap=\"round\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></template>";
// Exports
module.exports = code;